import { CountryCode, parsePhoneNumberFromString } from 'libphonenumber-js';

// Most numbers in the system are Czech and get typed without a prefix.
const DEFAULT_COUNTRY: CountryCode = 'CZ';

const INTERNATIONAL_PREFIX = /^(\+|00)/;

/**
 * Groups a phone number for display, following the conventions of the country
 * it belongs to. Numbers typed with an international prefix keep one
 * ("+420 777 888 999"), the rest are grouped nationally ("777 888 999").
 *
 * Anything that is not a valid number is shown exactly as it is stored - notes,
 * extensions and half-filled numbers stay readable instead of being mangled
 * into a shape they do not have.
 *
 * @param phoneNumber - the number as it is stored
 * @param defaultCountry - country to assume for numbers without a prefix (default CZ)
 */
export const formatPhoneNumber = (
    phoneNumber: string | null | undefined,
    defaultCountry: CountryCode = DEFAULT_COUNTRY,
): string => {
    if (!phoneNumber) return '';

    const parsed = parsePhoneNumberFromString(phoneNumber, defaultCountry);
    if (!parsed?.isValid()) return phoneNumber;

    return INTERNATIONAL_PREFIX.test(phoneNumber.trim()) ? parsed.formatInternational() : parsed.formatNational();
};
